const footer = {
  "footer.cookie": "Cookie Settings",
  "footer.about": "關於 ACUVUE®",
  "footer.contact": "聯絡我們",
  "footer.policy": "私隱政策",
  "footer.notice": "使用條款",
  "footer.legal": "<p>本網站由 Johnson & Johnson (HK) Ltd (下稱「強生」) 發布，僅供香港地區之授權用戶、強生及其關聯公司員工使用。使用本網站代表您已同意本網站所發布之「私隱權政策」、「法律聲明」及「標準銷售條款」。強生保留隨時更改上述政策、聲明或條款內容之權利。</p> <p>© Johnson & Johnson (HK) Ltd 2024.</p> <p>© Johnson & Johnson (HK) Ltd 2024保留所有權利。</p>",
}

export default footer
